import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { getMethod2 } from "../../functions/httpMethods";
import NunitoText from "../general/NunitoText";
import ReusableAutocompleteWithID from "../general/ReusableAutocompleteWithID";
import ReusableButton from "../general/ReusableButton";

const buildSeedOptions = (currentRank) =>
  currentRank !== null && currentRank !== undefined
    ? [{ id: currentRank, name: String(currentRank) }]
    : [];

export default function EditModerateRankingModal({
  setCurrentRowRanking,
  currentRowRanking,
  setEditModal,
  competitionId,
  updateRanking,
}) {
  const currentRank = currentRowRanking?.raw_rank;

  const [rank, setRank] = useState(() =>
    currentRank !== null && currentRank !== undefined ? currentRank : ""
  );
  const [options, setOptions] = useState(() => buildSeedOptions(currentRank));

  useEffect(() => {
    if (currentRank !== null && currentRank !== undefined) {
      setRank(currentRank);
      setOptions(buildSeedOptions(currentRank));
    } else {
      setRank("");
      setOptions([]);
    }
  }, [currentRowRanking]);

  useEffect(() => {
    if (!competitionId) return;

    getMethod2(
      `competition/team-based/simoc/${competitionId}/champions?get_filter=rank`,
      ""
    ).then((response) => {
      const rankOptions =
        response?.map((option) => ({
          id: option.filter_id,
          name: option.filter_name,
        })) || [];
      setOptions(rankOptions);

      if (currentRank !== null && currentRank !== undefined) {
        const matchedOption = rankOptions.find(
          (option) => option.id === currentRank || option.name === currentRank
        );
        if (matchedOption) setRank(matchedOption.id);
      }
    });
  }, [competitionId, currentRank]);

  const constructPayload = () => ({
    participant_index: currentRowRanking?.participant?.index_no,
    rank_id: Number(rank),
  });

  return (
    <Box
      className="popUpModal"
      style={{ width: 705, minHeight: 310 }}
      display={"flex"}
      alignItems={"center"}
      flexDirection={"column"}
    >
      <NunitoText
        value="Moderate Ranking"
        fontSize={30}
        fontWeight={600}
        color="#144A94"
        marginTop={30}
      />
      <ReusableAutocompleteWithID
        width={550}
        type={"default"}
        placeholder="Rank"
        state={rank}
        setState={setRank}
        borderColor="#707070"
        options={options.map((option) => ({
          id: option.id,
          option: option.name,
        }))}
      />

      <Grid
        container
        justifyContent="space-evenly"
        style={{ marginBlock: "30px 20px" }}
      >
        <ReusableButton
          text="Cancel"
          bgColor="#8D8D8D"
          fontSize={25}
          height={63}
          width={280}
          onClick={() => {
            setEditModal(false);
            setCurrentRowRanking();
          }}
        />
        <ReusableButton
          text="Confirm"
          bgColor="#5E75C3"
          fontSize={25}
          height={63}
          width={280}
          onClick={() => {
            updateRanking(constructPayload());
          }}
        />
      </Grid>
    </Box>
  );
}
